import { api, ApiRoutes } from './ApiService';
import { Type } from '../types/Type';

export const fetchTypes = async (): Promise<Type[]> => {
    try {
        const response = await api.get(ApiRoutes.TYPES_PUBLIC);
        
        if (response.data?.data?.types) {
            return response.data.data.types;
        } else if (response.data?.data) {
            return Array.isArray(response.data.data) ? response.data.data : [];
        }
        
        return [];
    } catch (error) {
        console.error('Failed to fetch types:', error);
        throw error;
    }
};

